import React, { useEffect, useState } from 'react';
import { listAttribute } from '../../services/app.service';
import { SelectFormView, SelectListFormView, SelectMultipleFormView, SelectRangeView } from './index.';

export const ATTRIBUTES = {
    activity_types: { id: 'Activity types', name: 'Activity types' },
    attractions: { id: 'Attractions', name: 'Attractions' },
    banner: { id: 'Banner', name: 'Banner group' },
    conditions: { id: 'Conditions', name: 'Conditions' },
    door: { id: 'Door', name: 'Door' },
    elevation_gain: { id: 'Elevation gain', name: 'Elevation gain' },
    difficulty: { id: 'Difficulty', name: 'Level' },
    parking: { id: 'Parking', name: 'Parking' },
    perk: { id: 'Perk', name: 'Perk' },
    // services: { id: 'Services', name: 'Services' },
    route_type: { id: 'Route format', name: 'Route format' },
    marathon_type: { id: 'Route type', name: 'Route type' },
    service_eat_local: { id: 'Service eat local', name: 'Service Eatlocal' },
    service_stay: { id: 'Service stay', name: 'Service Stay' },
    suitability: { id: 'Suitability', name: 'Suitability' },
    take_away: { id: 'Take away', name: 'Take away' },
    ticket_type: { id: 'Ticket types', name: 'Ticket types' },
    length: { id: 'Length', name: 'Trail length' },
    traffic: { id: 'Traffic', name: 'Vehicle' },
};

const AttributeContext = React.createContext<any>({});

export const AttributeProvider = ({ children }: any) => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<Array<any>>([]);

    useEffect(() => {
        loadData().then();
    }, []);

    const loadData = async () => {
        const result = await listAttribute({});
        if (result.status === 200) {
            setRows(
                (result?.data?.data?.items || []).sort((a: any, b: any) => {
                    const indexA = a?.index || 0;
                    const indexB = b?.index || 0;
                    return indexA > indexB ? 1 : indexA < indexB ? -1 : 0;
                })
            );
        }
    };

    const getValues = (category: any) => {
        return rows
            .filter((value) => value.group.toString().toLowerCase() === category.toString().toLowerCase())
            .map((value) => {
                return {
                    value: value.id,
                    label: value.name,
                };
            });
    };

    return (
        <AttributeContext.Provider
            value={{
                loading,
                setLoading,
                getValues,
            }}
        >
            {children}
        </AttributeContext.Provider>
    );
};

const useAttribute = () => React.useContext(AttributeContext);

export const FormAttributeSelectView = (props: any) => {
    const hook = useAttribute();
    const options = hook.getValues(props.category.id);

    return props.mode == 'multiple' ? (
        <SelectMultipleFormView
            options={options}
            loading={hook.loading}
            {...props}
            onChange={(value) => {
                props.onChange(value);
            }}
        />
    ) : (
        <SelectFormView
            options={options}
            loading={hook.loading}
            {...props}
            onChange={(value) => {
                props.onChange(value);
            }}
        />
    );
};

export const FormAttributeSelectListView = (props: any) => {
    const hook = useAttribute();
    const options = hook.getValues(props.category.id);

    return (
        <SelectListFormView
            options={options}
            loading={hook.loading}
            {...props}
            onChange={(value: any) => {
                props.onChange(value);
            }}
        />
    );
};

export const FormCategorySelectListView = (props: any) => {
    const hook = useAttribute();

    return (
        <SelectFormView
            options={props?.options}
            loading={hook.loading}
            {...props}
            onChange={(value) => {
                props.onChange(value);
            }}
        />
    );
};

export const FormAttributeSelectRangeView = (props: any) => {
    const hook = useAttribute();
    const options = hook.getValues(props.category.id);

    return (
        <SelectRangeView
            options={options}
            {...props}
            onChange={(value) => {
                props.onChange(value);
            }}
        />
    );
};
